module.exports = __webpack_public_path__ + "static/media/news_detail.c493c797.jpg";